module.exports = __webpack_public_path__ + "img/238-46599b.png";